<template>
  <div style="padding-bottom: 30px">
    <TopMenu @projectType="projectType" :projectNum="projectNum"></TopMenu>
    <div style="padding: 0 20px">
      <div class="flotleft">
        <el-date-picker size="small" v-model="pickDate" type="daterange" range-separator="~"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间" format="yyyy-MM-dd" @change="_search"
                        value-format="yyyy-MM-dd"></el-date-picker>
        <!-- <el-button type="primary" size="small" @click="_search()">查询</el-button> -->
        <el-input size="small" v-model="projectName" placeholder="请输入项目名称"
                  style="width: 200px; margin-left: 10px;" clearable/>
        <el-button type="primary" size="small" @click="_search" style="margin-left: 10px;">查询</el-button>
      </div>
      <div style="overflow: hidden;">
        <div class="flotright">
          <el-button type="primary" size="small" @click="_openrReportManager()" v-if="$_has('pr-add')">
            项目汇报
          </el-button>
        </div>
        <div class="flotright">
          <el-button type="primary" size="small" @click="overtime" v-if="$_has('pr-add')">加班汇总</el-button>
        </div>
        <div class="flotright">
          <el-button type="primary" size="small" @click="_createProject()" v-if="$_has('pr-add')">创建项目</el-button>
        </div>
      </div>
      <div class="block">
        <el-table
          ref="table"
          :data="projectData"
          stripe
          :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
          :header-cell-class-name="handleHeaderClass"
          style="width: 100%"
          border
          :height="'calc(100vh - 250px)'"
          @sort-change="sortChange"
        >
          <el-table-column label="序号" type="index" width="50" align="center"/>
          <!-- <el-table-column prop="id" label="ID"></el-table-column> -->
          <el-table-column prop="name" label="项目名称" sortable="custom" show-overflow-tooltip width="100">
            <template slot-scope="scope">
              <span @click="_gotoProjectDetail(scope.row)" class="projectname">{{ scope.row.name }}</span>
              <!-- <el-button
                type="text"
                style="width:100%"
                size="small"
                @click="_gotoProjectDetail(scope.row)"
              >{{scope.row.name}}</el-button> -->
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center" sortable="custom" width="100">
            <template #default="scope">
              {{ scope.row.createTime }}
            </template>
          </el-table-column>
          <el-table-column prop="versions" label="版本数" width="90" align="center" sortable="custom">
            <template slot-scope="scope">
              <el-button @click="_openVersionManager(scope.row.id)" type="text" size="small">
                {{ scope.row.versions }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="rdType" label="项目类型" align="center">
            <template slot-scope="scope">
              <label>{{ scope.row.rdType }}</label>
            </template>
          </el-table-column>
          <el-table-column prop="industryType" label="所属行业" align="center">
            <template slot-scope="scope">
              <label>{{ scope.row.industryType }}</label>
            </template>
          </el-table-column>
          <el-table-column prop="stage" label="项目阶段" align="center">
            <template slot-scope="scope">
              <label>{{ null == scope.row.projectVersionVO ? '-' : scope.row.projectVersionVO.stageName }}</label>
            </template>
          </el-table-column>
          <el-table-column prop="resourcePool" label="资源池" align="center">
            <template slot-scope="scope">
              <label>{{ null == scope.row.projectVersionVO ? '-' : scope.row.projectVersionVO.resourcePool }}</label>
            </template>
          </el-table-column>
          <el-table-column prop="riskPool" label="风险池" align="center">
            <template slot-scope="scope">
              <label>{{ null == scope.row.projectVersionVO ? '-' : scope.row.projectVersionVO.riskPool }}</label>
            </template>
          </el-table-column>
          <el-table-column prop="costResource" label="已耗资源" width="150" align="center">
            <template slot-scope="scope">
              <label v-if="scope.row.costResource">{{ scope.row.costResource }}人天({{
                  scope.row.costPercentage
                }}%)</label>
              <label v-else>--</label>
            </template>
          </el-table-column>
          <el-table-column prop="laveResource" label="剩余资源" align="center">
            <template slot-scope="scope">
              <label v-if="scope.row.laveResource">{{ scope.row.laveResource }}人天</label>
              <label v-else>--</label>
            </template>
          </el-table-column>
          <el-table-column prop="finishedTestProgressRate" width="180" label="实际进度">
            <template slot-scope="scope">
              <div class="flexboxitem"
                   v-if="scope.row.finishedTestProgressRate || scope.row.finishedTestProgressRate == 0">
                <label>{{ scope.row.finishedTestProgressRate }}%</label>
                <div class="line">
                  <div class="innerline" :style="{ width: _computeWidth(scope.row.finishedTestProgressRate) + '%' }">
                  </div>
                </div>
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column prop="progressWarningType" label="项目进度预警" width="120" align="center">
            <template slot-scope="scope">
              <label v-if="scope.row.progressWarningType"
                     :class="[{ 'success': scope.row.progressWarningType == 1 }, { 'normal': scope.row.progressWarningType == 2 }
                  , { 'warning': scope.row.progressWarningType == 3 }, { 'danger': scope.row.progressWarningType == 4 }]">{{
                  scope.row.progressWarningType ==
                  1 ? '正常' : (scope.row.progressWarningType == 2 ? '预警' : (scope.row.progressWarningType ==
                  3 ? '戒严' : (scope.row.progressWarningType == 4 ? '军警' : '--')))
                }}</label>
              <label v-else>--</label>
            </template>
          </el-table-column>
          <el-table-column prop label="参与成员" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="_gotoMember(scope.row.id)">查看成员</el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="150" align="center"
                           v-if="$_has('c-project') || $_has('d-project')">
            <template slot-scope="scope">
              <span v-if="$_has('c-project')">
                <el-button v-if="!scope.row.close" @click="_closeProject(scope.row.id)" type="text"
                           size="small">关闭项目</el-button>
                <el-button v-else-if="scope.row.projectVersionVO == null" type="text" size="small"
                           disabled>关闭项目</el-button>
                <el-button v-else type="text" size="small" disabled>已关闭</el-button>
              </span>
              <el-button @click="_deleteProject(scope.row)" v-if="$_has('d-project')" type="text"
                         size="small">删除项目
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div style="marin-top:15px">
        <!-- <pagination
          :pageTotal="totalNum"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @handleCurrentChange="_handleCurrentChange"
        /> -->
      </div>

      <el-dialog title="创建项目" :visible.sync="dialogFormVisible">
        <el-form :model="form" style="width:80%" @submit.native.prevent="_confirm">
          <el-form-item label="项目名称" :label-width="formLabelWidth" required>
            <el-input v-model="form.name" size="small"></el-input>
          </el-form-item>
          <el-form-item label="项目类型" :label-width="formLabelWidth" required>
            <el-select v-model="form.rdType" placeholder="选择项目类型" size="small" style="width:100%">
              <el-option v-for="item in rdList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目经理" :label-width="formLabelWidth" required>
            <el-button type="text" @click="clickSelectPmTree">{{ form.pmId ? form.pmName : '请选择项目经理' }}
            </el-button>
          </el-form-item>
          <el-form-item label="所属行业" :label-width="formLabelWidth" required>
            <el-select v-model="form.industryType" placeholder="选择所属行业" size="small" style="width:100%">
              <el-option v-for="item in industryList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目简介" :label-width="formLabelWidth">
            <el-input type="textarea" placeholder="项目简介" v-model="form.introduction" size="small"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="_confirm()" v-preventReClick size="small">创建</el-button>
        </div>
      </el-dialog>

      <!--  项目经理选择对话框  -->
      <el-dialog
        :before-close="()=>{
        pmDialog.dialogVisible=false
        pmDialog.treeSelected = ''
        pmDialog.query=undefined;
      }"
        width="50%"
        :visible="pmDialog.dialogVisible"
        title="项目经理"
      >
        <el-input
          v-model="pmDialog.query"
          clearable
          type="mini"
        />
        <span>请选择</span>
        <el-tree
          ref="pmTree"
          default-expand-all
          @node-click="treeClick"
          :data="pmDialog.treeData"
          :filter-node-method="filterNode"
        >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <i
            :class="isCheck(data)?'el-icon-success':'el-icon-circle-check'"
            v-if="checkboxShow(node,data)"
          />
          <span style="margin-left: 2px">{{ node.label }}</span>
        </span>
        </el-tree>
        <template slot="footer" class="dialog-footer">
          <el-button @click="pmDialogConfirm" type="primary" size="small">确定</el-button>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>

import dialogVue from "../../components/treeTable/dialog.vue";
import TopMenu from "./topMenu";
import {
  createProject,
  listProject,
  deleteProject,
  pageProject,
  listProjectVersion,
  updateProjectVersion,
  closeProject, getProjectPermission,
  getProjectStageNum,
  getStatisticsProjectVersionPartData
} from "./projectManagerAPI";
import {
  getCompanyDictPage,
  getDictGroup
} from "../system-manage/dict/dictAPI";
import {ProjectStageEnmus} from "utils/enmus";
import {funMenu, funProjectAuthority, getProjectItemAuthority} from "utils/common";
import {formatTreeAndPerson, getTreeAndPerson} from "./projectMember-manage/projectMemberAPI";

export default {
  data() {
    return {
      currentUser: JSON.parse(localStorage.getItem("currentUser")),
      projectStageEnmu: ProjectStageEnmus,
      //创建项目表单数据
      form: {},
      //项目类型
      rdList: [],
      //所属行业
      industryList: [],
      formLabelWidth: "120px",
      //创建项目弹框标记
      dialogFormVisible: false,
      //关闭版本弹框标记
      closeDialogVisiable: false,
      //选择时间
      pickDate: "",
      //项目data
      projectData: [],
      rowData: {},
      //项目版本data
      projectVersionData: [],
      newProjectVersion: {},
      //分页
      pageSize: -1,
      totalNum: 0,
      currentPage: 1,
      //页面type
      type: 0,
      projectNum: {},
      projectName: undefined,
      pmDialog: {
        query: undefined,
        dialogVisible: false,
        treeSelected: '',
        treeData: [
          {
            id: "1",
            label: "项目经理",
            children: []
          }
        ]
      },
      ordersList: [],
    };
  },
  created() {
    this._refreshData();
    // this._getProjectNum();
  },
  activated() {
    //this._refreshData();
  },
  watch: {
    ["pmDialog.query"](newValue, oldValue) {
      this.$refs.pmTree.filter(newValue);
    }
  },
  methods: {
    sortChange({column, prop, order}) {
      console.log("sortChange", column, prop, order)
      column.multiOrder = order;
      this.handleOrderChange(column.property, column.multiOrder);
    },
    handleOrderChange(orderColumn, orderState) {
      let result = this.ordersList.find((e) => e.orderColumn === orderColumn);
      if (result) {
        // 不排序就删掉
        if (!orderState) {
          for (let i = 0; i < this.ordersList.length; i++) {
            if (this.ordersList[i] === result) {
              this.ordersList.splice(i, 1);
              break;
            }
          }
        } else {
          result.orderState = orderState;
        }
      } else {
        this.ordersList.push({
          orderColumn: orderColumn,
          orderState: orderState,
        });
      }
      // 调接口查询，在传参的时候把ordersList进行处理成后端想要的格式
      console.log('this.ordersList : 排序列', this.ordersList);
      this._search();
    },
    // 设置列的排序为我们自定义的排序
    handleHeaderClass({column}) {
      // console.log('handleHeaderClass', column)
      column.order = column.multiOrder;
    },
    resetOrder() {
      this.$refs.table.clearSort();
      let columns = this.$refs.table.columns;
      columns.forEach((column) => {
        if (column.sortable == 'custom') {
          column.order = undefined;
          column.multiOrder = undefined;
        }
      });
      this.ordersList = [];
    },
    clickSelectPmTree() {
      getTreeAndPerson().then(res => {
        if (1000 === res.code) {
          this.pmDialog.treeData = formatTreeAndPerson(res.data);
        }
      })
      this.pmDialog.dialogVisible = true;
    },
    /***
     * 判断节点是否可以勾选
     */
    checkboxShow(node, data) {
      return !!data.id;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    /***
     * 判断当前是否选中
     */
    isCheck(data) {
      if (this.pmDialog.treeSelected.key === data.key) {
        console.log("结果为true");
        return true;
      }
      return false;
    },
    pmDialogConfirm() {
      // console.log("当前选择的项目经理", this.treeSelected);
      this.form.pmName = this.pmDialog.treeSelected.label;
      this.form.pmId = this.pmDialog.treeSelected.id;
      this.pmDialog.dialogVisible = false;
      this.pmDialog.query = undefined;
    },
    treeClick(data, node, element) {
      console.log("点击", data, node, element);
      if (data.id) {
        this.pmDialog.treeSelected = data;
      }
    },
    _createProject() {
      this.dialogFormVisible = true;
      this._getDictItem();
    },
    _computeWidth(e) {
      return e || 0
    },
    _cancel() {
      this.dialogFormVisible = false;
    },
    _confirm() {
      /**确认创建项目 */
      this.dialogFormVisible = false;
      this.form.employeeId = this.currentUser.id;
      createProject(this.form)
        .then(res => {
          if (res.code == 1000) {
            this.$message.success("创建成功");
            this._refreshData();
            this.form = {};
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
    _refreshData() {
      this.pickDate = '';
      //刷新页面
      let params = {
        current: 1,
        size: -1,
        type: this.type,
        employeeId: this.currentUser.id,
      };
      this._pageProject(params);
    },
    _pageProject(params) {
      pageProject(params)
        .then(res => {
          console.log(res.data.records);
          if (res.code == 1000) {
            this.$nextTick(() => {
              this.projectData = res.data.records;
              this.totalNum = res.data.total;
              this.currentPage = res.data.current;
              console.log(this.projectData);
              this._getProjectNum();
              this._getPool({
                projectVersionIdList: this.projectData.filter(v => v.projectVersionVO).map(i => i.projectVersionVO.id).join(',')
              })
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
    _getPool(params) {
      getStatisticsProjectVersionPartData(params).then(res => {
        let obj = res.data
        this.projectData.forEach(item => {
          if (item.projectVersionVO && obj[item.projectVersionVO.id]) {
            this.$set(item, 'costResource', obj[item.projectVersionVO.id].costResource)
            this.$set(item, 'laveResource', obj[item.projectVersionVO.id].laveResource)
            this.$set(item, 'finishedTestProgressRate', obj[item.projectVersionVO.id].finishedTestProgressRate)
            this.$set(item, 'progressWarningType', obj[item.projectVersionVO.id].progressWarningType)
            this.$set(item, 'costPercentage', obj[item.projectVersionVO.id].costPercentage)
          }
        })
      })
    },
    _search() {
      //根据时间查询
      var startTime;
      var endTime;
      if (null != this.pickDate && !this.pickDate == '') {
        startTime = this.pickDate[0];
        endTime = this.pickDate[1];
      }
      let params = {
        current: 1,
        size: this.pageSize,
        startTime: startTime,
        endTime: endTime,
        type: this.type,
        employeeId: this.currentUser.id,
        projectName: this.projectName,
      };
      let ordersStr="";
      this.ordersList.forEach(o => {
        ordersStr += o.orderColumn + "_" + (o.orderState === 'ascending' ? 0 : 1) + ",";
      });
      params.ordersStr = ordersStr.substring(0, ordersStr.length - 1);
      this._pageProject(params);
    },
    _getDictItem() {
      //查询数据字典
      //项目类型Code
      let params = {
        dictGroupCode: "R&D_TYPE"
      };
      getCompanyDictPage(params).then(res => {
        this.rdList = res.data.records;
      });
      //所属行业Code
      let params2 = {
        dictGroupCode: "INDUSTRY_TYPE"
      };
      getCompanyDictPage(params2).then(res => {
        this.industryList = res.data.records;
      });
    },
    // activated() {
    //   // this._refreshData();
    // },
    _closeProject(id) {
      this.$confirm("是否关闭该项目下的所有版本", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          closeProject(id).then(res => {
            if (res.code == 1000) {
              this._refreshData();
              this.$message.success("关闭成功")
            } else {
              this.$message.error(res.error)
            }
          })
        })
        .catch(() => {
        });
    },
    _deleteProject(row) {
      //删除项目
      this.rowData = row;
      this.$confirm("是否该删除项目？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteProject(this.rowData.id)
            .then(res => {
              this._refreshData();
              this.$message.success("删除成功");
            })
            .catch(err => {
            });
        })
        .catch(() => {
        });
    },
    _openVersionManager(id) {
      //跳转版本管理页面
      console.info("项目id:" + id);
      this.$router.push({
        path: "/project-manage/version/list",
        query: {projectId: id}
      });
      localStorage.setItem("projectId", id)
    },
    _openrReportManager() {
      //跳转项目汇报
      // console.info("项目id:" + id);
      this.$router.push({
        path: "/project-manage/report-manage/list",
        // query: { projectId: id }
      });
      // localStorage.setItem("projectId", id)
    },
    overtime() {
      this.$router.push({
        path: "/project-manage/overtime-manage/list",
      });
    },
    _handleSizeChange(val) {
      console.log(`每页${val}条`);
    },
    _handleCurrentChange(val) {
      let params = {
        current: val,
        size: this.pageSize,
        type: this.type,
        employeeId: this.currentUser.id,
      };
      this._pageProject(params);
    },
    _gotoProjectDetail(project) {
      console.log(project)
      if (project.projectVersionVO == null) {
        this.$message.warning("请先创建项目版本");
        setTimeout(() => {
          this.$confirm(`是否要去创建项目版本?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {

            this.$router.push({
              path: "/project-manage/version/list",
              query: {projectId: project.id}
            });
            localStorage.setItem("projectId", project.id)
          }).catch(() => {

          });
        }, 1000)
      } else {

        getProjectPermission(project.id).then(res => { // 项目权限
          if (res.code === 1000) {

            let temp = []
            temp = getProjectItemAuthority(res.data, temp)
            //  console.log('kkkkkk',res.data,temp)
            localStorage.setItem("projectAuthority", JSON.stringify(temp))
            this.$router.push({
              path: "/project-manage/new-start/NewStart",
              query: {
                projectId: project.id,
                projectName: project.name
              }
            });
            localStorage.setItem("projectId", project.id)

          }
        })
      }
    },
    _getProjectNum() {
      let params = {
        employeeId: this.currentUser.id
      }
      getProjectStageNum(params).then(res => {
        this.projectNum = res.data
      })
    },
    _gotoMember(id) {
      this.$router.push({path: '/project-manage/projectMember-manage/list', query: {projectId: id}})
    },
    projectType(type) {
      this.type = type;
      this._search();
    },
  },
  components: {
    TopMenu
  },

  _openVersionManager(id) {
    //跳转版本管理页面
    console.info("项目id:" + id);
    this.$router.push({
      path: "/project-manage/version/list",
      query: {projectId: id}
    });
    localStorage.setItem("projectId", id)
  },
  _handleSizeChange(val) {
    console.log(`每页${val}条`);
  },
  _handleCurrentChange(val) {
    let params = {
      current: val,
      size: this.pageSize,
      type: this.type,
      employeeId: this.currentUser.id,
    };
    this._pageProject(params);
  },
  _gotoProjectDetail(project) {
    console.log(project);
    this.$router.push({path: "/project-manage/new-start/NewStart", params: project.id});
  }
}
</script>

<style scoped>
.block >>> .el-table--border .el-table__cell, .block >>> .el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed {
  border-right: none;
}

.flotleft {
  float: left;
  margin-top: 10px;
  margin-bottom: 20px;
}

.flotright {
  float: right;
  margin-top: 10px;
  margin-bottom: 20px;
  margin-left: 20px;
}

.flexboxitem {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flexboxitem > label {
  white-space: nowrap;
  /* margin-right: 10px; */
}

.projectname {
  color: #409eff;
  font-size: 13px;
  cursor: pointer;
}

.line {
  width: 100px;
  height: 8px;
  border-radius: 7px;
  background: #c0c4cc;
  overflow: hidden;
  flex-shrink: 0;
  /* z-index: 20; */
}

.innerline {
  background: #67c23a;
  /* z-index: 30; */
  height: 100%;
}

.success {
  color: #67c23a;
}

.warning {
  color: #e6a23c;
}

.normal {
  color: #409eff;
}

.danger {
  color: #f56c6c;
}
</style>



// WEBPACK FOOTER //
// src/views/project-manage/projectManagerPannel.vue